
<div class="gpd-full-page custom" style="display: flex; gap: 10px;">
    <div class="div" style="display: flex; justify-content: space-between;">
    <dx-text-box [(value)]="searchTerm" mode="search" (offClick)="doSearch($event)" valueChangeEvent="keyup"
      width="350px" class="gt-search-panel search-float-off-toolbar" (onValueChanged)="dataGridSearch.instance.searchByText($event.value)"
      i18n-placeholder="@@mastrSearch" placeholder="Search MaStr..." style="border-radius: 8px; border-color: var(--color-grey-300);">
   </dx-text-box>
    <app-gpd-button i18n-text="@@addmastr"
            text="ADD ROW" (onClick)="addRow($event)" icon="add">
    </app-gpd-button>
    </div>
    <dx-data-grid #mastrGrid id="mastrGrid" keyExpr="id" [dataSource]="mastr" (onRowInserting)="initNewRow($event)"
        class="gt-data-grid-style overflow-x" height="100%" (onSaved)="saveChanges($event)"
        (onEditingStart)="onEditingStart($event)" (onInitNewRow)="onInitNewRow()" (onEditCanceled)="onEditCanceled()"
        [editing]="{ mode: 'form', texts: { saveRowChanges: confirmText, cancelRowChanges: cancelText }}"
        [allowColumnResizing]="true" [columnResizingMode]="'widget'" [columnAutoWidth]="false" [showBorders]="true"
        [scrolling]="{ mode: 'standard', useNative: true }" [width]="'100%'" [rowAlternationEnabled]="true"
        [hoverStateEnabled]="true">
        <dxi-column dataField="nameOfUnit" i18n-caption="@@nameOfUnit" caption="Name of Unit"
            [editorOptions]="{maxLength: 50}">
            <dxo-form-item>
                <dxi-validation-rule type="required" i18n-message message="required">
                </dxi-validation-rule>
            </dxo-form-item>
        </dxi-column>
        <dxi-column dataField="nrOfUnit" i18n-caption="@@nrOfUnit" caption="Nr. of Unit"
            [editorOptions]="{maxLength: 50}">
            <dxo-form-item>
            </dxo-form-item>
        </dxi-column>
        <dxi-column dataField="nrOfLocation" i18n-caption="@@nrOfLocation" caption="Nr. of Location"
            [editorOptions]="{maxLength: 50}">
            <dxo-form-item>
            </dxo-form-item>
        </dxi-column>
        <dxi-column dataField="nrOfEegPlant" i18n-caption="@@nrOfEegPlant" caption="Nr. of EEG Plant"
            [editorOptions]="{maxLength: 50}">
            <dxo-form-item>
            </dxo-form-item>
        </dxi-column>
        <dxi-column dataField="bNetARegNr" i18n-caption="@@bNetARegNr" caption="BNetA Registationnr."
            [editorOptions]="{maxLength: 50}">
            <dxo-form-item>
            </dxo-form-item>
        </dxi-column>

        <!--         <dxi-column dataField="remunerationRate" i18n-caption="@@remunerationRate ct/kWh"
            caption="Remuneration Rate (ct/kWh)" (onValueChanged)="reFormatNumber($event)"
            [editorOptions]="{maxLength: 16,format: '#,##0.#####',max: 9999999999.99999, min: 0, onKeyUp: reFormatNumber}">
            <dxo-form-item editorType="dxNumberBox"
                [editorOptions]="{maxLength: 16,format: '#,##0.#####',max: 9999999999.99999, min: 0, onKeyUp: reFormatNumber}">
            </dxo-form-item>
        </dxi-column> -->

        <dxi-column dataField="remunerationRate" i18n-caption="@@remunerationRate ct/kWh" dataType="number"
            format="#,##0.##" caption="Remuneration Rate (ct/kWh)" editCellTemplate="editRemunerationRateTemplate">
            <dxi-validation-rule type="range" i18n-message message="max 5 digits before and after the decimal point"
                [min]="0" [max]="99999.99999"></dxi-validation-rule>
            <div *dxTemplate="let item of 'editRemunerationRateTemplate'">
                <dx-number-box [(value)]="item.data.remunerationRate" (onValueChanged)="item.setValue($event.value)"
                    format="#,##0.##">
                </dx-number-box>
            </div>
        </dxi-column>

        <!--         <dxi-column dataField="powerOutputOfUnit" i18n-caption="@@powerOutputOfUnit" caption="Power Output of Unit"
            (onValueChanged)="reFormatNumber($event)"
            [editorOptions]="{maxLength:21,format: '#,##0.###',max: 999999999999999999.999, min: 0, onKeyUp: reFormatNumber}">
            <dxo-form-item editorType="dxNumberBox"
                [editorOptions]="{maxLength: 21,format: '#,##0.###',max: 999999999999999999.999, min: 0, onKeyUp: reFormatNumber}">
            </dxo-form-item>
        </dxi-column> -->

        <dxi-column dataField="powerOutputOfUnit" i18n-caption="@@powerOutputOfUnit" caption="Power Output of Unit"
            editCellTemplate="editPowerOutputTemplate" format="#,##0.##">
            <div *dxTemplate="let item of 'editPowerOutputTemplate'">
                <dx-number-box [(value)]="item.data.powerOutputOfUnit" (onValueChanged)="item.setValue($event.value)"
                    format="#,##0.##"> </dx-number-box>
            </div>
        </dxi-column>

        <!--         <dxi-column dataField="maxPowerOutputOfUnit" i18n-caption="@@maxPowerOutputOfUnit"
            caption="Max Power Output of Unit" (onValueChanged)="reFormatNumber($event)"
            [editorOptions]="{maxLength:21,format: '#,##0.###',max: 999999999999999999.999, min: 0, onKeyUp: reFormatNumber}">
            <dxo-form-item editorType="dxNumberBox"
                [editorOptions]="{maxLength: 21,format: '#,##0.###',max: 999999999999999999.999, min: 0, onKeyUp: reFormatNumber}">
            </dxo-form-item>
        </dxi-column> -->

        <dxi-column dataField="maxPowerOutputOfUnit" i18n-caption="@@maxPowerOutputOfUnit"
            caption="Max Power Output of Unit" editCellTemplate="editMaxPowerOutputTemplate"
            [format]="formatNumberConvetionsThree">
            <div *dxTemplate="let item of 'editMaxPowerOutputTemplate'">
                <dx-number-box [(value)]="item.data.maxPowerOutputOfUnit" (onValueChanged)="item.setValue($event.value)"
                    format="#.##0,###">
                </dx-number-box>
            </div>
        </dxi-column>

        <dxi-column dataField="conformityDocument" i18n-caption="@@conformityDocument" caption="Conformity confirmation"
            [width]="240" [allowSorting]="false" cellTemplate="conformityDocTemplate"
            editCellTemplate="conformityDocEditTemplate" [formItem]="{visible: true, colSpan: 2}">
            <div *dxTemplate="let item of 'conformityDocTemplate'">
                <ng-container *ngIf="item.data.id > 0">
                    <app-document-pill *ngIf="gridPill(item.data) as pill; else noDoc" [value]="pill"></app-document-pill>
                    <ng-template #noDoc>
                        <dx-button *ngIf="canEdit" icon="upload" i18n-text="@@conformityDocumentGridUpload" text="Upload" stylingMode="outlined"
                            [disabled]="busy" (onClick)="gridInput.click()"></dx-button>
                        <input #gridInput type="file" accept=".pdf,image/*" hidden
                            (change)="onGridFilePicked($event, item.data)" />
                    </ng-template>
                </ng-container>
            </div>
            <div *dxTemplate="let item of 'conformityDocEditTemplate'">
                <div class="conformity-form-doc">
                    <app-document-pill *ngIf="formPill" [value]="formPill"></app-document-pill>
                    <span *ngIf="staged.file">{{ staged.file.name }}</span>
                    <dx-button *ngIf="canEdit && (formPill || staged.file)" [disabled]="busy" icon="close" stylingMode="text"
                        i18n-hint="@@conformityDocumentRemove" hint="Remove" (onClick)="stageRemove(item)"></dx-button>
                    <dx-button *ngIf="canEdit && !formPill && !staged.file" [disabled]="busy" icon="upload" i18n-text="@@conformityDocumentUpload"
                        text="Upload conformity confirmation" stylingMode="outlined"
                        (onClick)="formInput.click()"></dx-button>
                    <input #formInput type="file" accept=".pdf,image/*" hidden
                        (change)="onFormFilePicked($event, item)" />
                </div>
            </div>
        </dxi-column>
        <!-- Hidden column: only visible in the edit form, renders the DELETE button aligned with CONFIRM/CANCEL -->
        <dxi-column dataField="_deleteAction" caption="" [visible]="false"
            editCellTemplate="deleteInFormTemplate"
            [formItem]="{visible: true, label: {visible: false}, cssClass: 'delete-form-item'}">
            <div *dxTemplate="let item of 'deleteInFormTemplate'">
                <dx-button *ngIf="currentEditingItem && currentEditingItem.id > 0"
                    i18n-text="@@deleteCaps" text="DELETE" type="danger" stylingMode="contained"
                    (onClick)="onFormDeleteClick()">
                </dx-button>
            </div>
        </dxi-column>

        <dxi-column dataField="none" caption="" [visible]="true" cellTemplate="buttonCellTemplate" width="40px"
            [formItem]="{visible: false}">
            <div *dxTemplate="let item of 'buttonCellTemplate'">
                <div class="cell-with-buttons">
                    <div class="cell-button-container">
                        <dx-button icon="edit" class="cell-button"
                            (onClick)="editRow($event, item.rowIndex)"></dx-button>
                    </div>
                </div>
            </div>
        </dxi-column>
    </dx-data-grid>
</div>

<app-delete-popup (onConfirm)="onConfirm($event)" (onAbort)="onAbort($event)" [message]="deleteMessage"
    [visible]="deletePopupVisible">
</app-delete-popup>

<dx-toast [visible]="toastTwoVisible" [type]="type" message="{{message}}" position="bottom center" width="fit-content">
</dx-toast>
